/**
 * typeBusiness da company:
 * 1 = escolar
 * 2 = corporativo
 */

export function normalizeTypeBusiness(value) {
    if (value === 2 || value === '2') return 2;
    if (value === 1 || value === '1') return 1;
    return null;
}

export function isCorporateTypeBusiness(value) {
    return normalizeTypeBusiness(value) === 2;
}

/** Login admin (`/login`): type 1 (gestor) ou 2 (administrador). */
export function isAdminUserType(type) {
    const n = Number(type);
    return n === 1 || n === 2;
}

/**
 * Resolve typeBusiness a partir de company / website.company.
 * O login do portal deve chamar syncAdminModeFromTypeBusiness para não
 * herdar company persistida de outra empresa.
 */
export function resolveTypeBusinessFromState(state = {}) {
    const company = state.company;
    if (company && typeof company === 'object' && !Array.isArray(company)) {
        const fromCompany = normalizeTypeBusiness(company.typeBusiness);
        if (fromCompany != null) return fromCompany;
    }

    const website = state.websites;
    const nested = website && typeof website === 'object' && !Array.isArray(website)
        ? website.company
        : null;
    if (nested && typeof nested === 'object') {
        const fromWebsite = normalizeTypeBusiness(nested.typeBusiness);
        if (fromWebsite != null) return fromWebsite;
    }

    return null;
}

export function companyPayloadFromWebsite(website) {
    const company = website?.company;
    if (!company || typeof company !== 'object') return null;
    const typeBusiness = normalizeTypeBusiness(company.typeBusiness);
    return {
        ...company,
        typeBusiness: typeBusiness ?? company.typeBusiness,
        isCorporate: typeBusiness === 2,
        platform_type: typeBusiness === 2 ? 'corporate' : 'school',
    };
}
